exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-tag{cursor:pointer;padding:.2em .5em}.ebx-tag--is-selected{background:#d3d3d3}", ""]);
